import { type ReactNode, useId } from 'react';

/** One of the page's cards (board 3.1): a heading, an optional count or hint, an action. */
export function Card({
  title,
  hint,
  action,
  children,
}: {
  readonly title: string;
  readonly hint?: ReactNode;
  readonly action?: ReactNode;
  readonly children: ReactNode;
}) {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className="border-border bg-card flex min-w-0 flex-col gap-3 rounded-xl border p-4"
    >
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <h3 id={headingId} className="text-base font-bold">
          {title}
        </h3>
        {hint ? <span className="text-muted-foreground text-xs">{hint}</span> : null}
        {action ? <span className="ml-auto">{action}</span> : null}
      </div>
      {children}
    </section>
  );
}
